import { http } from 'connex-cds';
import { getLocationInfo } from '../../util/getLocationInfo';

export default {
  listUsers: ({ entityRef, options }) =>
    http.get({ apiName: 'mt', path: `/${entityRef}/users`, queryParams: { isHauler: options.isHauler || undefined } }),
  inviteUser: ({ entityRef, user }) =>
    http.post({
      apiName: 'mt',
      path: `/${entityRef}/users/invite`,
      data: { ...user, locationInfo: getLocationInfo() },
    }),
  register: ({ entityRef, payload }) =>
    http.post({ apiName: 'mt', path: `/users/register/${entityRef}`, data: payload }),
  getUserRole: ({ entityRef, profileRef }) =>
    http.get({ apiName: 'mt', path: `/${entityRef}/profiles/${profileRef}/roles` }),
  getUserRbac: ({ entityRef, profileRef }) =>
    http.get({ apiName: 'mt', path: `/admin/${entityRef}/users/${profileRef}/rbac` }),
};
